import { render, staticRenderFns } from "./dots-inline.vue?vue&type=template&id=1b964f7c&"
import script from "./dots-inline.vue?vue&type=script&lang=js&"
export * from "./dots-inline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b964f7c')) {
      api.createRecord('1b964f7c', component.options)
    } else {
      api.reload('1b964f7c', component.options)
    }
    module.hot.accept("./dots-inline.vue?vue&type=template&id=1b964f7c&", function () {
      api.rerender('1b964f7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/dots-inline.vue"
export default component.exports